import { Controller } from "@hotwired/stimulus"

// Hides an element for good once its close button is used (per browser: localStorage key), e.g. the chat tips.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.dismissed) this.element.remove()
  }

  dismiss() {
    try { localStorage.setItem(this.keyValue, "1") } catch (_e) { /* private mode: dismiss for this page only */ }
    this.element.remove()
  }

  get dismissed() {
    try { return localStorage.getItem(this.keyValue) === "1" } catch (_e) { return false }
  }
}
